module.exports = __webpack_public_path__ + "pic/14.03748075.png";